<template>
  <Transition name="slide-fadeUp" appear>
    <div v-if="visible" class="modal-center">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-header-left">
            <span class="modal-header-txt">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M8 5.75C7.59 5.75 7.25 5.41 7.25 5V2C7.25 1.59 7.59 1.25 8 1.25C8.41 1.25 8.75 1.59 8.75 2V5C8.75 5.41 8.41 5.75 8 5.75Z"
                  fill="#4A68F8"/>
              <path
                  d="M16 5.75C15.59 5.75 15.25 5.41 15.25 5V2C15.25 1.59 15.59 1.25 16 1.25C16.41 1.25 16.75 1.59 16.75 2V5C16.75 5.41 16.41 5.75 16 5.75Z"
                  fill="#4A68F8"/>
              <path opacity="0.4"
                    d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z"
                    fill="#4A68F8"/>
              <path
                  d="M16 11.75H8C7.59 11.75 7.25 11.41 7.25 11C7.25 10.59 7.59 10.25 8 10.25H16C16.41 10.25 16.75 10.59 16.75 11C16.75 11.41 16.41 11.75 16 11.75Z"
                  fill="#4A68F8"/>
              <path
                  d="M12 16.75H8C7.59 16.75 7.25 16.41 7.25 16C7.25 15.59 7.59 15.25 8 15.25H12C12.41 15.25 12.75 15.59 12.75 16C12.75 16.41 12.41 16.75 12 16.75Z"
                  fill="#4A68F8"/>
            </svg>{{ $t('file_program_create') }}
            </span>
            <span class="modal-header-description">{{ $t('transform_program_description') }}</span>
          </div>

          <div class="modal-header-right">
            <button type="button" class="close-btn" data-dismiss="modal" aria-label="Close">
              <img src="@/assets/images/cross.svg" class="cross" @click="onHide"/>
            </button>
          </div>
        </div>

        <div class="tab-wrapper mt-3">
          <button
              class="tab-item"
              :class="{'active': activeTab === 'compare'}"
              @click="setActiveTab('compare')"
          >
            {{$t('file_vs')}}
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3C5.23858 3 3 5.23858 3 8C3 10.7614 5.23858 13 8 13ZM8.89268 10.5669L8.97252 10.2405C8.93119 10.2599 8.86456 10.2821 8.77319 10.3073C8.68157 10.3326 8.59912 10.3454 8.52665 10.3454C8.37229 10.3454 8.26362 10.3201 8.20052 10.2693C8.13789 10.2184 8.10665 10.1227 8.10665 9.98262C8.10665 9.9271 8.11607 9.84434 8.13579 9.73602C8.15489 9.62699 8.17686 9.53009 8.20129 9.44533L8.49935 8.39007C8.52855 8.29322 8.54857 8.18675 8.55933 8.07055C8.57034 7.9546 8.57546 7.87348 8.57546 7.82744C8.57546 7.60491 8.49746 7.42433 8.34141 7.28503C8.18536 7.14583 7.96315 7.07623 7.67517 7.07623C7.51492 7.07623 7.34551 7.10471 7.16621 7.1616C6.98691 7.21835 6.79946 7.28672 6.60337 7.36656L6.52332 7.6932C6.58175 7.67159 6.65135 7.64834 6.73278 7.62427C6.81386 7.6003 6.89339 7.58791 6.97078 7.58791C7.12877 7.58791 7.23519 7.61485 7.29096 7.6679C7.34674 7.72112 7.37475 7.81576 7.37475 7.95107C7.37475 8.02589 7.36589 8.10901 7.3475 8.19935C7.32937 8.29025 7.30674 8.38638 7.28011 8.48784L6.98076 9.54735C6.95413 9.65869 6.93467 9.7583 6.92243 9.84675C6.91029 9.93509 6.90445 10.0218 6.90445 10.1061C6.90445 10.3239 6.98491 10.5034 7.14577 10.645C7.30664 10.7861 7.53218 10.8571 7.82215 10.8571C8.01098 10.8571 8.17671 10.8325 8.31934 10.7828C8.46181 10.7334 8.65315 10.6614 8.89268 10.5669ZM8.83957 6.28016C8.97882 6.15105 9.04811 5.99403 9.04811 5.81017C9.04811 5.62673 8.97892 5.4694 8.83957 5.33865C8.70068 5.20826 8.53326 5.14286 8.33752 5.14286C8.14116 5.14286 7.97308 5.2081 7.83286 5.33865C7.69263 5.4694 7.62237 5.62667 7.62237 5.81017C7.62237 5.99403 7.69263 6.151 7.83286 6.28016C7.97334 6.40973 8.14111 6.47457 8.33752 6.47457C8.53331 6.47457 8.70068 6.40973 8.83957 6.28016Z"
                    fill="#D0D5DD"/>
            </svg>
          </button>
          <button
              class="tab-item"
              :class="{'active': activeTab === 'transform'}"
              @click="setActiveTab('transform')"
          >
            {{$t('file_conversion')}}
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3C5.23858 3 3 5.23858 3 8C3 10.7614 5.23858 13 8 13ZM8.89268 10.5669L8.97252 10.2405C8.93119 10.2599 8.86456 10.2821 8.77319 10.3073C8.68157 10.3326 8.59912 10.3454 8.52665 10.3454C8.37229 10.3454 8.26362 10.3201 8.20052 10.2693C8.13789 10.2184 8.10665 10.1227 8.10665 9.98262C8.10665 9.9271 8.11607 9.84434 8.13579 9.73602C8.15489 9.62699 8.17686 9.53009 8.20129 9.44533L8.49935 8.39007C8.52855 8.29322 8.54857 8.18675 8.55933 8.07055C8.57034 7.9546 8.57546 7.87348 8.57546 7.82744C8.57546 7.60491 8.49746 7.42433 8.34141 7.28503C8.18536 7.14583 7.96315 7.07623 7.67517 7.07623C7.51492 7.07623 7.34551 7.10471 7.16621 7.1616C6.98691 7.21835 6.79946 7.28672 6.60337 7.36656L6.52332 7.6932C6.58175 7.67159 6.65135 7.64834 6.73278 7.62427C6.81386 7.6003 6.89339 7.58791 6.97078 7.58791C7.12877 7.58791 7.23519 7.61485 7.29096 7.6679C7.34674 7.72112 7.37475 7.81576 7.37475 7.95107C7.37475 8.02589 7.36589 8.10901 7.3475 8.19935C7.32937 8.29025 7.30674 8.38638 7.28011 8.48784L6.98076 9.54735C6.95413 9.65869 6.93467 9.7583 6.92243 9.84675C6.91029 9.93509 6.90445 10.0218 6.90445 10.1061C6.90445 10.3239 6.98491 10.5034 7.14577 10.645C7.30664 10.7861 7.53218 10.8571 7.82215 10.8571C8.01098 10.8571 8.17671 10.8325 8.31934 10.7828C8.46181 10.7334 8.65315 10.6614 8.89268 10.5669ZM8.83957 6.28016C8.97882 6.15105 9.04811 5.99403 9.04811 5.81017C9.04811 5.62673 8.97892 5.4694 8.83957 5.33865C8.70068 5.20826 8.53326 5.14286 8.33752 5.14286C8.14116 5.14286 7.97308 5.2081 7.83286 5.33865C7.69263 5.4694 7.62237 5.62667 7.62237 5.81017C7.62237 5.99403 7.69263 6.151 7.83286 6.28016C7.97334 6.40973 8.14111 6.47457 8.33752 6.47457C8.53331 6.47457 8.70068 6.40973 8.83957 6.28016Z"
                    fill="#D0D5DD"/>
            </svg>
          </button>
        </div>

        <div v-if="activeTab === 'transform'">
          <div class="upload-banner">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.56589 11.5994C5.38769 10.8356 4.58369 10.211 4.25369 9.7994C3.68861 9.09337 3.33446 8.24208 3.23205 7.34358C3.12964 6.44508 3.28313 5.53592 3.67485 4.72085C4.06656 3.90577 4.68056 3.21792 5.44611 2.73655C6.21166 2.25518 7.09763 1.99986 8.00194 2C8.90626 2.00014 9.79214 2.25575 10.5575 2.73737C11.3229 3.21899 11.9367 3.90703 12.3282 4.72223C12.7196 5.53744 12.8728 6.44664 12.7701 7.34511C12.6674 8.24358 12.313 9.09476 11.7477 9.8006C11.4177 10.2116 10.6149 10.8362 10.4367 11.5994H5.56529H5.56589ZM10.4013 12.7994V13.3994C10.4013 13.7177 10.2749 14.0229 10.0498 14.2479C9.82478 14.473 9.51955 14.5994 9.20129 14.5994H6.80129C6.48303 14.5994 6.17781 14.473 5.95277 14.2479C5.72772 14.0229 5.60129 13.7177 5.60129 13.3994V12.7994H10.4013ZM8.60129 6.8024V4.3994L5.90129 8.0024H7.40129V10.4024L10.1013 6.8024H8.60129Z" fill="#4A68F8"/>
            </svg>
            {{$t('tip_note')}}
          </div>

          <div class="upload-wrapper" style="width: 100%; gap: 10px;">
            <input type="file" id="transform-file-1" style="display: none" @change="onFileInputChange($event, 0, 'transform')"
                   accept=".pdf,.doc,.docx,.ppt,.pptx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation">
            <input type="file" id="transform-file-2" style="display: none" @change="onFileInputChange($event, 1, 'transform')"
                   accept=".pdf,.doc,.docx,.ppt,.pptx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation">
            <input type="file" id="transform-file-3" style="display: none" @change="onFileInputChange($event, 2, 'transform')"
                   accept=".pdf,.doc,.docx,.ppt,.pptx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation">

            <div class="upload-file"
                 style="width: 33%; margin-top: 0;"
                 :class="{'has-file': transformFiles[0]}"
                 @click="onUploadClick(0, 'transform')"
                 @dragenter.prevent="setDragActive(0, 'transform')"
                 @dragover.prevent="setDragActive(0, 'transform')"
                 @dragleave.prevent="setDragInactive(0, 'transform')"
                 @drop.prevent="onDrop($event, 0, 'transform')">

              <template v-if="!transformFiles[0]">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.9998 12.5274L15.8185 16.3452L14.545 17.6187L12.8998 15.9735V21H11.0998V15.9717L9.45461 17.6187L8.18111 16.3452L11.9998 12.5274ZM11.9998 3C13.5451 3.00007 15.0365 3.568 16.1904 4.59581C17.3443 5.62361 18.0803 7.03962 18.2584 8.5746C19.3782 8.87998 20.3552 9.56919 21.0184 10.5218C21.6816 11.4744 21.989 12.6297 21.8869 13.786C21.7847 14.9422 21.2794 16.0257 20.4594 16.8472C19.6394 17.6687 18.5567 18.1759 17.4007 18.2802V16.4676C17.8149 16.4085 18.2131 16.2674 18.5721 16.0527C18.9312 15.8379 19.2439 15.5539 19.4919 15.217C19.74 14.8801 19.9184 14.4972 20.0169 14.0906C20.1153 13.6839 20.1318 13.2618 20.0653 12.8488C19.9989 12.4357 19.8508 12.0401 19.6298 11.6849C19.4087 11.3297 19.1191 11.0221 18.7779 10.78C18.4367 10.538 18.0506 10.3663 17.6424 10.2751C17.2341 10.1838 16.8117 10.1748 16.3999 10.2486C16.5409 9.5924 16.5332 8.91297 16.3776 8.2601C16.222 7.60722 15.9223 6.99743 15.5004 6.47538C15.0786 5.95333 14.5454 5.53225 13.9397 5.24298C13.3341 4.9537 12.6714 4.80357 12.0003 4.80357C11.3291 4.80357 10.6664 4.9537 10.0608 5.24298C9.45515 5.53225 8.92189 5.95333 8.50007 6.47538C8.07825 6.99743 7.77854 7.60722 7.62291 8.2601C7.46728 8.91297 7.45966 9.5924 7.60061 10.2486C6.7795 10.0944 5.93076 10.2727 5.24112 10.7443C4.55147 11.2159 4.0774 11.9421 3.92321 12.7632C3.76901 13.5843 3.94731 14.433 4.41889 15.1227C4.89047 15.8123 5.6167 16.2864 6.43781 16.4406L6.59981 16.4676V18.2802C5.44371 18.1761 4.36097 17.669 3.54083 16.8476C2.72068 16.0261 2.2153 14.9426 2.11301 13.7863C2.01073 12.6301 2.31804 11.4747 2.98124 10.522C3.64444 9.56934 4.62134 8.88005 5.74121 8.5746C5.91914 7.03954 6.65507 5.62342 7.80903 4.59558C8.96298 3.56774 10.4545 2.99988 11.9998 3Z" fill="#328A33"/>
                </svg>
                <h5>{{$t('file_selected')}}</h5>
                <span>PDF,DOC,PPT</span>
              </template>

              <template v-else>
                <div class="file-preview-new">
                  <div class="file-type-badge" :class="getFileTypeClass(transformFiles[0].name)">
                    <span class="file-type-text">{{ getFileExtension(transformFiles[0].name).toUpperCase() }}</span>
                  </div>

                  <div class="file-info">
                    <h5 class="file-title">{{ truncate(transformFiles[0].name, 15) }}</h5>
                    <p class="file-details">{{ formatFileSize(transformFiles[0].size) }} • %100</p>
                  </div>

                  <div class="file-actions">
                    <svg @click.stop="removeFile(0, 'transform')" class="remove-file-btn-new" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.25 4V2.5H13.75V4H17.5V5.5H16V16.75C16 16.9489 15.921 17.1397 15.7803 17.2803C15.6397 17.421 15.4489 17.5 15.25 17.5H4.75C4.55109 17.5 4.36032 17.421 4.21967 17.2803C4.07902 17.1397 4 16.9489 4 16.75V5.5H2.5V4H6.25ZM5.5 5.5V16H14.5V5.5H5.5ZM7.75 7.75H9.25V13.75H7.75V7.75ZM10.75 7.75H12.25V13.75H10.75V7.75Z" fill="#667085"/>
                    </svg>
                  </div>
                </div>
              </template>
            </div>

            <div class="upload-file"
                 style="width: 33%; margin-top: 0;"
                 :class="{'has-file': transformFiles[1]}"
                 @click="onUploadClick(1, 'transform')"
                 @dragenter.prevent="setDragActive(1, 'transform')"
                 @dragover.prevent="setDragActive(1, 'transform')"
                 @dragleave.prevent="setDragInactive(1, 'transform')"
                 @drop.prevent="onDrop($event, 1, 'transform')">

              <template v-if="!transformFiles[1]">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.9998 12.5274L15.8185 16.3452L14.545 17.6187L12.8998 15.9735V21H11.0998V15.9717L9.45461 17.6187L8.18111 16.3452L11.9998 12.5274ZM11.9998 3C13.5451 3.00007 15.0365 3.568 16.1904 4.59581C17.3443 5.62361 18.0803 7.03962 18.2584 8.5746C19.3782 8.87998 20.3552 9.56919 21.0184 10.5218C21.6816 11.4744 21.989 12.6297 21.8869 13.786C21.7847 14.9422 21.2794 16.0257 20.4594 16.8472C19.6394 17.6687 18.5567 18.1759 17.4007 18.2802V16.4676C17.8149 16.4085 18.2131 16.2674 18.5721 16.0527C18.9312 15.8379 19.2439 15.5539 19.4919 15.217C19.74 14.8801 19.9184 14.4972 20.0169 14.0906C20.1153 13.6839 20.1318 13.2618 20.0653 12.8488C19.9989 12.4357 19.8508 12.0401 19.6298 11.6849C19.4087 11.3297 19.1191 11.0221 18.7779 10.78C18.4367 10.538 18.0506 10.3663 17.6424 10.2751C17.2341 10.1838 16.8117 10.1748 16.3999 10.2486C16.5409 9.5924 16.5332 8.91297 16.3776 8.2601C16.222 7.60722 15.9223 6.99743 15.5004 6.47538C15.0786 5.95333 14.5454 5.53225 13.9397 5.24298C13.3341 4.9537 12.6714 4.80357 12.0003 4.80357C11.3291 4.80357 10.6664 4.9537 10.0608 5.24298C9.45515 5.53225 8.92189 5.95333 8.50007 6.47538C8.07825 6.99743 7.77854 7.60722 7.62291 8.2601C7.46728 8.91297 7.45966 9.5924 7.60061 10.2486C6.7795 10.0944 5.93076 10.2727 5.24112 10.7443C4.55147 11.2159 4.0774 11.9421 3.92321 12.7632C3.76901 13.5843 3.94731 14.433 4.41889 15.1227C4.89047 15.8123 5.6167 16.2864 6.43781 16.4406L6.59981 16.4676V18.2802C5.44371 18.1761 4.36097 17.669 3.54083 16.8476C2.72068 16.0261 2.2153 14.9426 2.11301 13.7863C2.01073 12.6301 2.31804 11.4747 2.98124 10.522C3.64444 9.56934 4.62134 8.88005 5.74121 8.5746C5.91914 7.03954 6.65507 5.62342 7.80903 4.59558C8.96298 3.56774 10.4545 2.99988 11.9998 3Z" fill="#328A33"/>
                </svg>
                <h5>{{$t('file_selected')}}</h5>
                <span>PDF,DOC,PPT</span>
              </template>

              <template v-else>
                <div class="file-preview-new">
                  <div class="file-type-badge" :class="getFileTypeClass(transformFiles[1].name)">
                    <span class="file-type-text">{{ getFileExtension(transformFiles[1].name).toUpperCase() }}</span>
                  </div>

                  <div class="file-info">
                    <h5 class="file-title">{{ truncate(transformFiles[1].name, 15) }}</h5>
                    <p class="file-details">{{ formatFileSize(transformFiles[1].size) }} • %100</p>
                  </div>

                  <div class="file-actions">
                    <svg @click.stop="removeFile(1, 'transform')" class="remove-file-btn-new" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.25 4V2.5H13.75V4H17.5V5.5H16V16.75C16 16.9489 15.921 17.1397 15.7803 17.2803C15.6397 17.421 15.4489 17.5 15.25 17.5H4.75C4.55109 17.5 4.36032 17.421 4.21967 17.2803C4.07902 17.1397 4 16.9489 4 16.75V5.5H2.5V4H6.25ZM5.5 5.5V16H14.5V5.5H5.5ZM7.75 7.75H9.25V13.75H7.75V7.75ZM10.75 7.75H12.25V13.75H10.75V7.75Z" fill="#667085"/>
                    </svg>
                  </div>
                </div>
              </template>
            </div>

            <div class="upload-file"
                 style="width: 33%; margin-top: 0;"
                 :class="{'has-file': transformFiles[2]}"
                 @click="onUploadClick(2, 'transform')"
                 @dragenter.prevent="setDragActive(2, 'transform')"
                 @dragover.prevent="setDragActive(2, 'transform')"
                 @dragleave.prevent="setDragInactive(2, 'transform')"
                 @drop.prevent="onDrop($event, 2, 'transform')">

              <template v-if="!transformFiles[2]">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.9998 12.5274L15.8185 16.3452L14.545 17.6187L12.8998 15.9735V21H11.0998V15.9717L9.45461 17.6187L8.18111 16.3452L11.9998 12.5274ZM11.9998 3C13.5451 3.00007 15.0365 3.568 16.1904 4.59581C17.3443 5.62361 18.0803 7.03962 18.2584 8.5746C19.3782 8.87998 20.3552 9.56919 21.0184 10.5218C21.6816 11.4744 21.989 12.6297 21.8869 13.786C21.7847 14.9422 21.2794 16.0257 20.4594 16.8472C19.6394 17.6687 18.5567 18.1759 17.4007 18.2802V16.4676C17.8149 16.4085 18.2131 16.2674 18.5721 16.0527C18.9312 15.8379 19.2439 15.5539 19.4919 15.217C19.74 14.8801 19.9184 14.4972 20.0169 14.0906C20.1153 13.6839 20.1318 13.2618 20.0653 12.8488C19.9989 12.4357 19.8508 12.0401 19.6298 11.6849C19.4087 11.3297 19.1191 11.0221 18.7779 10.78C18.4367 10.538 18.0506 10.3663 17.6424 10.2751C17.2341 10.1838 16.8117 10.1748 16.3999 10.2486C16.5409 9.5924 16.5332 8.91297 16.3776 8.2601C16.222 7.60722 15.9223 6.99743 15.5004 6.47538C15.0786 5.95333 14.5454 5.53225 13.9397 5.24298C13.3341 4.9537 12.6714 4.80357 12.0003 4.80357C11.3291 4.80357 10.6664 4.9537 10.0608 5.24298C9.45515 5.53225 8.92189 5.95333 8.50007 6.47538C8.07825 6.99743 7.77854 7.60722 7.62291 8.2601C7.46728 8.91297 7.45966 9.5924 7.60061 10.2486C6.7795 10.0944 5.93076 10.2727 5.24112 10.7443C4.55147 11.2159 4.0774 11.9421 3.92321 12.7632C3.76901 13.5843 3.94731 14.433 4.41889 15.1227C4.89047 15.8123 5.6167 16.2864 6.43781 16.4406L6.59981 16.4676V18.2802C5.44371 18.1761 4.36097 17.669 3.54083 16.8476C2.72068 16.0261 2.2153 14.9426 2.11301 13.7863C2.01073 12.6301 2.31804 11.4747 2.98124 10.522C3.64444 9.56934 4.62134 8.88005 5.74121 8.5746C5.91914 7.03954 6.65507 5.62342 7.80903 4.59558C8.96298 3.56774 10.4545 2.99988 11.9998 3Z" fill="#328A33"/>
                </svg>
                <h5>{{$t('file_selected')}}</h5>
                <span>PDF,DOC,PPT</span>
              </template>

              <template v-else>
                <div class="file-preview-new">
                  <div class="file-type-badge" :class="getFileTypeClass(transformFiles[2].name)">
                    <span class="file-type-text">{{ getFileExtension(transformFiles[2].name).toUpperCase() }}</span>
                  </div>

                  <div class="file-info">
                    <h5 class="file-title">{{ truncate(transformFiles[2].name, 15) }}</h5>
                    <p class="file-details">{{ formatFileSize(transformFiles[2].size) }} • %100</p>
                  </div>

                  <div class="file-actions">
                    <svg @click.stop="removeFile(2, 'transform')" class="remove-file-btn-new" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.25 4V2.5H13.75V4H17.5V5.5H16V16.75C16 16.9489 15.921 17.1397 15.7803 17.2803C15.6397 17.421 15.4489 17.5 15.25 17.5H4.75C4.55109 17.5 4.36032 17.421 4.21967 17.2803C4.07902 17.1397 4 16.9489 4 16.75V5.5H2.5V4H6.25ZM5.5 5.5V16H14.5V5.5H5.5ZM7.75 7.75H9.25V13.75H7.75V7.75ZM10.75 7.75H12.25V13.75H10.75V7.75Z" fill="#667085"/>
                    </svg>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <span class="upload-error-span" v-if="hasError.length > 0">{{ hasError }}</span>

          <span class="translation-title mt-3">{{$t('conversion_selected')}}</span>
          <div class="type-row">
            <label class="radio-item">
              <input
                  type="radio"
                  name="transformType"
                  value="basic"
                  v-model="selectedType"
                  class="radio-input"
              >
              <span class="radio-custom"></span>
              <span class="radio-label">{{ $t('basic_transform') }}</span>
            </label>

            <label class="radio-item">
              <input
                  type="radio"
                  name="transformType"
                  value="advanced"
                  v-model="selectedType"
                  class="radio-input"
              >
              <span class="radio-custom"></span>
              <span class="radio-label">{{ $t('advanced_transform') }}</span>
            </label>
          </div>

          <div class="settings-wrapper">
            <span>{{$t('generate_videos_description')}}</span>
            <Switch v-model="generateVideos" />
          </div>

          <div class="settings-wrapper">
            <span>{{$t('storytelling_mode')}}</span>
            <Switch v-model="storytellingMode" />
          </div>

          <div class="dropdown-wrapper mt-3">
            <span>{{$t('selected_language')}}</span>

            <SelectBox
                :full-width="true"
                :search-enabled="true"
              :options="languageOptions"
              v-model="selectedLanguageCode"
              :placeholder="$t('select_language')"
              @change="lang => selectLanguage(lang)"
            />

          </div>

          <textarea class="form-textarea mt-3" rows="4"
                    :placeholder="$t('Dönüştürme ile ilgili varsa spesifik talimatlarınız ekleyiniz.')"
                    v-model="transformInstructions"></textarea>

          <button class="primary-button mt-3" @click="handleTransformProgram" :disabled="transformLoading || getAllFiles('transform').length === 0"
                  :class="{'opacity-50 cursor-not-allowed': transformLoading || getAllFiles('transform').length === 0}">
            {{$t('create_program')}}
          </button>
        </div>

        <div v-if="activeTab === 'compare'">
          <div v-if="getAllFiles('compare').length > 0" class="existing-documents mt-2"></div>

          <div class="upload-banner">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.56589 11.5994C5.38769 10.8356 4.58369 10.211 4.25369 9.7994C3.68861 9.09337 3.33446 8.24208 3.23205 7.34358C3.12964 6.44508 3.28313 5.53592 3.67485 4.72085C4.06656 3.90577 4.68056 3.21792 5.44611 2.73655C6.21166 2.25518 7.09763 1.99986 8.00194 2C8.90626 2.00014 9.79214 2.25575 10.5575 2.73737C11.3229 3.21899 11.9367 3.90703 12.3282 4.72223C12.7196 5.53744 12.8728 6.44664 12.7701 7.34511C12.6674 8.24358 12.313 9.09476 11.7477 9.8006C11.4177 10.2116 10.6149 10.8362 10.4367 11.5994H5.56529H5.56589ZM10.4013 12.7994V13.3994C10.4013 13.7177 10.2749 14.0229 10.0498 14.2479C9.82478 14.473 9.51955 14.5994 9.20129 14.5994H6.80129C6.48303 14.5994 6.17781 14.473 5.95277 14.2479C5.72772 14.0229 5.60129 13.7177 5.60129 13.3994V12.7994H10.4013ZM8.60129 6.8024V4.3994L5.90129 8.0024H7.40129V10.4024L10.1013 6.8024H8.60129Z" fill="#4A68F8"/>
            </svg>
            {{$t('tip_description')}}
          </div>

          <div class="upload-wrapper" style="width: 100%; gap: 10px;">
            <input type="file" id="compare-file-1" style="display: none" @change="onFileInputChange($event, 0, 'compare')"
                   accept=".pdf,.doc,.docx,.ppt,.pptx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation">
            <input type="file" id="compare-file-2" style="display: none" @change="onFileInputChange($event, 1, 'compare')"
                   accept=".pdf,.doc,.docx,.ppt,.pptx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation">

            <div class="upload-file"
                 style="width: 47.5%; margin-top: 0;"
                 :class="{'has-file': compareFiles[0]}"
                 @click="onUploadClick(0, 'compare')"
                 @dragenter.prevent="setDragActive(0, 'compare')"
                 @dragover.prevent="setDragActive(0, 'compare')"
                 @dragleave.prevent="setDragInactive(0, 'compare')"
                 @drop.prevent="onDrop($event, 0, 'compare')">

              <template v-if="!compareFiles[0]">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.9998 12.5274L15.8185 16.3452L14.545 17.6187L12.8998 15.9735V21H11.0998V15.9717L9.45461 17.6187L8.18111 16.3452L11.9998 12.5274ZM11.9998 3C13.5451 3.00007 15.0365 3.568 16.1904 4.59581C17.3443 5.62361 18.0803 7.03962 18.2584 8.5746C19.3782 8.87998 20.3552 9.56919 21.0184 10.5218C21.6816 11.4744 21.989 12.6297 21.8869 13.786C21.7847 14.9422 21.2794 16.0257 20.4594 16.8472C19.6394 17.6687 18.5567 18.1759 17.4007 18.2802V16.4676C17.8149 16.4085 18.2131 16.2674 18.5721 16.0527C18.9312 15.8379 19.2439 15.5539 19.4919 15.217C19.74 14.8801 19.9184 14.4972 20.0169 14.0906C20.1153 13.6839 20.1318 13.2618 20.0653 12.8488C19.9989 12.4357 19.8508 12.0401 19.6298 11.6849C19.4087 11.3297 19.1191 11.0221 18.7779 10.78C18.4367 10.538 18.0506 10.3663 17.6424 10.2751C17.2341 10.1838 16.8117 10.1748 16.3999 10.2486C16.5409 9.5924 16.5332 8.91297 16.3776 8.2601C16.222 7.60722 15.9223 6.99743 15.5004 6.47538C15.0786 5.95333 14.5454 5.53225 13.9397 5.24298C13.3341 4.9537 12.6714 4.80357 12.0003 4.80357C11.3291 4.80357 10.6664 4.9537 10.0608 5.24298C9.45515 5.53225 8.92189 5.95333 8.50007 6.47538C8.07825 6.99743 7.77854 7.60722 7.62291 8.2601C7.46728 8.91297 7.45966 9.5924 7.60061 10.2486C6.7795 10.0944 5.93076 10.2727 5.24112 10.7443C4.55147 11.2159 4.0774 11.9421 3.92321 12.7632C3.76901 13.5843 3.94731 14.433 4.41889 15.1227C4.89047 15.8123 5.6167 16.2864 6.43781 16.4406L6.59981 16.4676V18.2802C5.44371 18.1761 4.36097 17.669 3.54083 16.8476C2.72068 16.0261 2.2153 14.9426 2.11301 13.7863C2.01073 12.6301 2.31804 11.4747 2.98124 10.522C3.64444 9.56934 4.62134 8.88005 5.74121 8.5746C5.91914 7.03954 6.65507 5.62342 7.80903 4.59558C8.96298 3.56774 10.4545 2.99988 11.9998 3Z" fill="#328A33"/>
                </svg>
                <h5>{{$t('file_selected')}}</h5>
                <span>PDF,DOC,PPT</span>
              </template>

              <template v-else>
                <div class="file-preview-new">
                  <div class="file-type-badge" :class="getFileTypeClass(compareFiles[0].name)">
                    <span class="file-type-text">{{ getFileExtension(compareFiles[0].name).toUpperCase() }}</span>
                  </div>

                  <div class="file-info">
                    <h5 class="file-title">{{ truncate(compareFiles[0].name, 15) }}</h5>
                    <p class="file-details">{{ formatFileSize(compareFiles[0].size) }} • %100</p>
                  </div>

                  <div class="file-actions">
                    <svg @click.stop="removeFile(0, 'compare')" class="remove-file-btn-new" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.25 4V2.5H13.75V4H17.5V5.5H16V16.75C16 16.9489 15.921 17.1397 15.7803 17.2803C15.6397 17.421 15.4489 17.5 15.25 17.5H4.75C4.55109 17.5 4.36032 17.421 4.21967 17.2803C4.07902 17.1397 4 16.9489 4 16.75V5.5H2.5V4H6.25ZM5.5 5.5V16H14.5V5.5H5.5ZM7.75 7.75H9.25V13.75H7.75V7.75ZM10.75 7.75H12.25V13.75H10.75V7.75Z" fill="#667085"/>
                    </svg>
                  </div>
                </div>
              </template>
            </div>

            <div class="vs-wrapper">
              <span>VS</span>
            </div>

            <div class="upload-file"
                 style="width: 47.5%; margin-top: 0;"
                 :class="{'has-file': compareFiles[1]}"
                 @click="onUploadClick(1, 'compare')"
                 @dragenter.prevent="setDragActive(1, 'compare')"
                 @dragover.prevent="setDragActive(1, 'compare')"
                 @dragleave.prevent="setDragInactive(1, 'compare')"
                 @drop.prevent="onDrop($event, 1, 'compare')">

              <template v-if="!compareFiles[1]">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.9998 12.5274L15.8185 16.3452L14.545 17.6187L12.8998 15.9735V21H11.0998V15.9717L9.45461 17.6187L8.18111 16.3452L11.9998 12.5274ZM11.9998 3C13.5451 3.00007 15.0365 3.568 16.1904 4.59581C17.3443 5.62361 18.0803 7.03962 18.2584 8.5746C19.3782 8.87998 20.3552 9.56919 21.0184 10.5218C21.6816 11.4744 21.989 12.6297 21.8869 13.786C21.7847 14.9422 21.2794 16.0257 20.4594 16.8472C19.6394 17.6687 18.5567 18.1759 17.4007 18.2802V16.4676C17.8149 16.4085 18.2131 16.2674 18.5721 16.0527C18.9312 15.8379 19.2439 15.5539 19.4919 15.217C19.74 14.8801 19.9184 14.4972 20.0169 14.0906C20.1153 13.6839 20.1318 13.2618 20.0653 12.8488C19.9989 12.4357 19.8508 12.0401 19.6298 11.6849C19.4087 11.3297 19.1191 11.0221 18.7779 10.78C18.4367 10.538 18.0506 10.3663 17.6424 10.2751C17.2341 10.1838 16.8117 10.1748 16.3999 10.2486C16.5409 9.5924 16.5332 8.91297 16.3776 8.2601C16.222 7.60722 15.9223 6.99743 15.5004 6.47538C15.0786 5.95333 14.5454 5.53225 13.9397 5.24298C13.3341 4.9537 12.6714 4.80357 12.0003 4.80357C11.3291 4.80357 10.6664 4.9537 10.0608 5.24298C9.45515 5.53225 8.92189 5.95333 8.50007 6.47538C8.07825 6.99743 7.77854 7.60722 7.62291 8.2601C7.46728 8.91297 7.45966 9.5924 7.60061 10.2486C6.7795 10.0944 5.93076 10.2727 5.24112 10.7443C4.55147 11.2159 4.0774 11.9421 3.92321 12.7632C3.76901 13.5843 3.94731 14.433 4.41889 15.1227C4.89047 15.8123 5.6167 16.2864 6.43781 16.4406L6.59981 16.4676V18.2802C5.44371 18.1761 4.36097 17.669 3.54083 16.8476C2.72068 16.0261 2.2153 14.9426 2.11301 13.7863C2.01073 12.6301 2.31804 11.4747 2.98124 10.522C3.64444 9.56934 4.62134 8.88005 5.74121 8.5746C5.91914 7.03954 6.65507 5.62342 7.80903 4.59558C8.96298 3.56774 10.4545 2.99988 11.9998 3Z" fill="#328A33"/>
                </svg>
                <h5>{{$t('file_selected')}}</h5>
                <span>PDF,DOC,PPT</span>
              </template>

              <template v-else>
                <div class="file-preview-new">
                  <div class="file-type-badge" :class="getFileTypeClass(compareFiles[1].name)">
                    <span class="file-type-text">{{ getFileExtension(compareFiles[1].name).toUpperCase() }}</span>
                  </div>

                  <div class="file-info">
                    <h5 class="file-title">{{ truncate(compareFiles[1].name, 15) }}</h5>
                    <p class="file-details">{{ formatFileSize(compareFiles[1].size) }} • %100</p>
                  </div>

                  <div class="file-actions">
                    <svg @click.stop="removeFile(1, 'compare')" class="remove-file-btn-new" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.25 4V2.5H13.75V4H17.5V5.5H16V16.75C16 16.9489 15.921 17.1397 15.7803 17.2803C15.6397 17.421 15.4489 17.5 15.25 17.5H4.75C4.55109 17.5 4.36032 17.421 4.21967 17.2803C4.07902 17.1397 4 16.9489 4 16.75V5.5H2.5V4H6.25ZM5.5 5.5V16H14.5V5.5H5.5ZM7.75 7.75H9.25V13.75H7.75V7.75ZM10.75 7.75H12.25V13.75H10.75V7.75Z" fill="#667085"/>
                    </svg>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <span class="upload-error-span" v-if="compareError.length > 0">{{ compareError }}</span>

          <span class="translation-title mt-3">{{$t('conversion_selected')}}</span>
          <div class="type-row">
            <label class="radio-item">
              <input
                  type="radio"
                  name="compareType"
                  value="basic"
                  v-model="selectedCompareType"
                  class="radio-input"
              >
              <span class="radio-custom"></span>
              <span class="radio-label">{{ $t('basic_transform') }}</span>
            </label>

            <label class="radio-item">
              <input
                  type="radio"
                  name="compareType"
                  value="advanced"
                  v-model="selectedCompareType"
                  class="radio-input"
              >
              <span class="radio-custom"></span>
              <span class="radio-label">{{ $t('advanced_transform') }}</span>
            </label>
          </div>

          <div class="settings-wrapper">
            <span>{{$t('generate_videos_description')}}</span>
            <Switch v-model="compareGenerateVideos" />
          </div>

          <div class="dropdown-wrapper mt-3">
            <span>{{$t('selected_language')}}</span>

            <SelectBox
                :full-width="true"
                :search-enabled="true"
                :options="languageOptions"
                v-model="selectedLanguageCode"
                :placeholder="$t('select_language')"
                @change="lang => selectLanguage(lang)"
            />
          </div>

          <textarea class="form-textarea mt-3" rows="4"
                    :placeholder="$t('conversion_placeholder')"
                    v-model="compareInstructions"></textarea>

          <button class="primary-button mt-3" @click="handleCompareProgram" :disabled="compareLoading || getAllFiles('compare').length === 0"
                  :class="{'opacity-50 cursor-not-allowed': compareLoading || getAllFiles('compare').length === 0}">
            {{$t('create_program')}}
          </button>
        </div>

        <div class="footer-controls mt-2">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 16.25C13.4518 16.25 16.25 13.4518 16.25 10C16.25 6.54822 13.4518 3.75 10 3.75C6.54822 3.75 3.75 6.54822 3.75 10C3.75 13.4518 6.54822 16.25 10 16.25ZM11.1158 13.2086L11.2156 12.8006C11.164 12.8249 11.0807 12.8526 10.9665 12.8841C10.852 12.9157 10.7489 12.9318 10.6583 12.9318C10.4654 12.9318 10.3295 12.9001 10.2507 12.8366C10.1724 12.773 10.1333 12.6534 10.1333 12.4783C10.1333 12.4089 10.1451 12.3054 10.1697 12.17C10.1936 12.0337 10.2211 11.9126 10.2516 11.8067L10.6242 10.4876C10.6607 10.3665 10.6857 10.2334 10.6992 10.0882C10.7129 9.94325 10.7193 9.84185 10.7193 9.78429C10.7193 9.50614 10.6218 9.28041 10.4268 9.10629C10.2317 8.93229 9.95393 8.84529 9.59396 8.84529C9.39365 8.84529 9.18188 8.88088 8.95776 8.952C8.73363 9.02294 8.49933 9.1084 8.25421 9.2082L8.15415 9.6165C8.22719 9.58949 8.31419 9.56043 8.41598 9.53034C8.51732 9.50038 8.61674 9.48489 8.71347 9.48489C8.91096 9.48489 9.04399 9.51856 9.1137 9.58488C9.18342 9.65139 9.21844 9.7697 9.21844 9.93883C9.21844 10.0324 9.20736 10.1363 9.18438 10.2492C9.16172 10.3628 9.13342 10.483 9.10013 10.6098L8.72595 11.9342C8.69266 12.0734 8.66834 12.1979 8.65304 12.3084C8.63786 12.4189 8.63057 12.5272 8.63057 12.6326C8.63057 12.9048 8.73114 13.1292 8.93222 13.3063C9.13329 13.4826 9.41523 13.5714 9.77769 13.5714C10.0137 13.5714 10.2209 13.5406 10.3992 13.4785C10.5773 13.4167 10.8164 13.3268 11.1158 13.2086ZM11.0495 7.8502C11.2235 7.68882 11.3101 7.49254 11.3101 7.26272C11.3101 7.03341 11.2236 6.83675 11.0495 6.67331C10.8758 6.51032 10.6666 6.42857 10.4219 6.42857C10.1765 6.42857 9.96635 6.51013 9.79107 6.67331C9.61579 6.83675 9.52796 7.03334 9.52796 7.26272C9.52796 7.49254 9.61579 7.68875 9.79107 7.8502C9.96667 8.01217 10.1764 8.09321 10.4219 8.09321C10.6666 8.09321 10.8758 8.01217 11.0495 7.8502Z" fill="#D0D5DD"/>
          </svg>
          <span>{{$t('file_conversion_footer_info')}}</span>
        </div>

      </div>
    </div>
  </Transition>
</template>

<script>
import FileDrop from "@/components/FileDrop.vue";
import {handleErrorResponse, truncate} from "@/utils/utils";
import aiService from "@/service/aiService";
import ExpandableSetting from "@/components/ExpandableSetting.vue";
import { LANGUAGES } from '@/lang/constants/languages.js';
import SelectBox from "@/components/SelectBox.vue";
import Switch from "@/components/Switch.vue";

export default {
  components: {
    Switch,
    SelectBox,
    ExpandableSetting,
    FileDrop,
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    onHide: {
      type: Function,
      default: () => {}
    },
  },

  data() {
    return {
      activeTab: 'compare',
      LANGUAGES,
      selectedLanguageCode: 'tr',
      languageDropdownOpen: false,
      transformFiles: [null, null, null],
      transformLoading: false,
      hasError: '',
      transformInstructions: '',
      selectedType: 'basic',
      generateVideos: false,
      storytellingMode: true,
      compareFiles: [null, null],
      compareLoading: false,
      compareError: '',
      compareInstructions: '',
      selectedCompareType: 'basic',
      compareGenerateVideos: false,
    }
  },

  computed: {
    selectedLanguage() {
      return this.LANGUAGES.find(lang => lang.code === this.selectedLanguageCode) || this.LANGUAGES[0];
    },
    languageOptions() {
      return this.LANGUAGES.map(lang => ({ value: lang.code, text: lang.name }));
    }
  },

  methods: {
    truncate,

    setActiveTab(tab) {
      this.activeTab = tab;
    },

    handleFileChange(file, index, fileType) {
      if (!this.validateFile(file)) return;

      if (fileType === 'transform') {
        this.transformFiles[index] = file;
        this.hasError = '';
      } else if (fileType === 'compare') {
        this.compareFiles[index] = file;
        this.compareError = '';
      }
    },

    removeFile(index, fileType) {
      if (fileType === 'transform') {
        this.transformFiles[index] = null;
      } else if (fileType === 'compare') {
        this.compareFiles[index] = null;
      }
    },

    getAllFiles(fileType) {
      const files = fileType === 'transform' ? this.transformFiles : this.compareFiles;
      return files.filter(file => file !== null && file !== undefined);
    },

    validateFile(file) {
      if (!file) return false;

      if (file.size > 1024 * 1024 * 10) {
        this.setError('File size should be less than 10MB');
        return false;
      }

      const allowedExtensions = ['pdf', 'doc', 'docx', 'ppt', 'pptx'];
      const extension = this.getFileExtension(file.name).toLowerCase();

      if (!allowedExtensions.includes(extension)) {
        this.setError('File type not supported');
        return false;
      }

      return true;
    },

    setError(message) {
      if (this.activeTab === 'transform') {
        this.hasError = message;
        setTimeout(() => { this.hasError = ''; }, 3000);
      } else {
        this.compareError = message;
        setTimeout(() => { this.compareError = ''; }, 3000);
      }
    },

    getFileExtension(filename) {
      if (!filename) return '';
      return filename.split('.').pop().toLowerCase();
    },

    getFileTypeClass(filename) {
      if (!filename) return 'file-type-default';
      const extension = this.getFileExtension(filename);
      const typeMap = {
        pdf: 'file-type-pdf',
        doc: 'file-type-doc',
        docx: 'file-type-doc',
        ppt: 'file-type-ppt',
        pptx: 'file-type-ppt'
      };
      return typeMap[extension] || 'file-type-default';
    },

    formatFileSize(bytes) {
      if (!bytes || bytes === 0) return '0 B';
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
    },

    toggleLanguageDropdown() {
      this.languageDropdownOpen = !this.languageDropdownOpen;
    },

    selectLanguage(language) {
      this.selectedLanguageCode = language.code;
      this.languageDropdownOpen = false;
    },

    async handleTransformProgram() {
      const files = this.getAllFiles('transform');

      if (!files.length) {
        this.hasError = 'Lütfen en az bir dosya seçiniz.';
        setTimeout(() => { this.hasError = ''; }, 3000);
        return;
      }

      await this.processProgram(files, {
        type: this.selectedType,
        instructions: this.transformInstructions,
        loadingKey: 'transformLoading',
        generateVideos: this.generateVideos,
        enableStorytelling: this.storytellingMode
      });
    },

    async handleCompareProgram() {
      const files = this.getAllFiles('compare');

      if (!files.length) {
        this.compareError = 'Lütfen en az bir dosya seçiniz.';
        setTimeout(() => { this.compareError = ''; }, 3000);
        return;
      }

      await this.processProgram(files, {
        type: this.selectedCompareType,
        instructions: this.compareInstructions,
        loadingKey: 'compareLoading',
        generateVideos: this.compareGenerateVideos,
      }, true
      );
    },

    async processProgram(files, options, isCompare = false) {
      const user = JSON.parse(localStorage.getItem('user'));

      if (!user?.userId || !user?.token) {
        this.setError('Kullanıcı bilgileri bulunamadı.');
        return;
      }

      this[options.loadingKey] = true;

      try {
        const formData = new FormData();

        files.forEach(file => {
          if (file) formData.append('documents', file);
        });

        const updatedPrompt =  `${options.instructions}. İçerikleri KESİNLİKLE ${this.selectedLanguage.name} dilinde yaz.`;

        formData.append('userId', user.userId);
        formData.append('extraPrompt', updatedPrompt);
        formData.append('type', options.type);
        formData.append('token', user.token);
        formData.append('generateVideos', options.generateVideos);
        formData.append('enableStorytelling', options.enableStorytelling);
        formData.append('isCompare', isCompare);

        await aiService.transformProgram(formData);

        this.$snackbar.add({
          text: 'İşlem başlatıldı, tamamlandığında bilgilendirileceksiniz',
          type: 'success'
        });

        this.onHide();

      } catch (error) {
        handleErrorResponse(error, this.$snackbar);
      } finally {
        this[options.loadingKey] = false;
      }
    },

    onFileInputChange(e, index, fileType) {
      const files = e.target.files;
      if (files && files.length > 0) {
        this.handleFileChange(files[0], index, fileType);
        e.target.value = "";
      }
    },

    onUploadClick(index, fileType) {
      const fileId = fileType === 'transform' ? `transform-file-${index + 1}` : `compare-file-${index + 1}`;
      document.getElementById(fileId)?.click();
    },

    setDragActive(index, fileType) {},

    setDragInactive(index, fileType) {},

    onDrop(e, index, fileType) {
      const files = e.dataTransfer.files;
      if (files && files.length > 0) {
        this.handleFileChange(files[0], index, fileType);
      }
    }
  }
};
</script>

<style scoped>
.modal-content {
  position: relative;
  background-color: white;
  border-radius: 12px;
  max-width: 35%;
  height: 90%;
  padding: 20px !important;
  overflow-y: auto;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
}

.modal-content::-webkit-scrollbar {
  width: 15px;
}

.modal-content::-webkit-scrollbar-track {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  background-color: #FFF;
}

.modal-content::-webkit-scrollbar-thumb {
  background-color: rgba(4, 12, 45, 0.2);
  border-radius: 10px;
  border: 5px transparent solid;
  background-clip: padding-box;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background-color: rgba(4, 12, 45, 0.4);
}

.close-btn {
  border: none;
  cursor: pointer;
  background-color: #F2F4F7;
  border-radius: 3000px;
}

.cross {
  padding: 8px;
}

.upload-wrapper {
  display: flex;
  flex-direction: row;
  gap: 20px;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
}

.upload-file {
  border-radius: 12px;
  border: 1px dashed #D0D5DD;
  background: #FFF;
  width: 50%;
  height: 150px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
}

.upload-file.has-file {
  border: 1px solid #D1D5DB;
  background: #FFFFFF;
  height: 120px;
}

.file-preview-new {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 8px;
  position: relative;
  justify-content: space-between;
}

.file-type-badge {
  position: absolute;
  top: 6px;
  left: 6px;
  border-radius: 3px;
  padding: 1px 4px;
  z-index: 2;
}

.file-info {
  margin-top: 25px;
  text-align: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.file-title {
  font-family: euclid_medium, sans-serif;
  font-size: 12px;
  color: #344054;
  margin: 0 0 2px 0;
  line-height: 1.2;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-details {
  font-family: euclid_regular, sans-serif;
  font-size: 10px;
  color: #667085;
  margin: 0;
}

.progress-bar {
  width: calc(100% - 16px);
  height: 3px;
  background-color: #F2F4F7;
  border-radius: 2px;
  margin: 6px 8px 8px 8px;
  overflow: hidden;
}

.file-actions {
  position: absolute;
  right: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  z-index: 2;
}

.file-type-pdf {
  background: #FEF3F2;
  border: 1px solid #FECDCA;
}

.file-type-pdf .file-type-text {
  color: #B42318;
}

.file-type-doc {
  background: #EFF8FF;
  border: 1px solid #B2DDFF;
}

.file-type-doc .file-type-text {
  color: #175CD3;
}

.file-type-ppt {
  background: #FFFAEB;
  border: 1px solid #FEDF89;
}

.file-type-ppt .file-type-text {
  color: #B54708;
}

.file-type-text {
  font-family: euclid_medium, sans-serif;
  font-size: 10px;
  font-weight: 500;
}

.vs-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F2F4F7;
  border-radius: 12px;
  height: 24px;
  width: 24px;
}

.vs-wrapper span {
  font-family: euclid_medium, sans-serif;
  font-size: 10px;
  color: #667085;
}

.upload-file.active {
  border-radius: 12px;
  border: 1px solid #4A68F8;
  background: #EBEDFB;
  width: 100%;
}

.upload-icon {
  color: #667085;
  height: 24px;
  width: 24px;
  margin-bottom: 10px;
}

.upload-file.active .upload-icon {
  color: #4A68F8;
}

.upload-file h5 {
  font-family: euclid_medium, sans-serif;
  color: #667085;
  font-size: 12px;
  font-style: normal;
  line-height: 20px;
  margin: 0;
  transition: all 0.3s ease;
}

.upload-file.active h5 {
  color: #4A68F8;
}

.upload-file span {
  font-family: euclid_regular, sans-serif;
  color: #D0D5DD;
  font-size: 12px;
  font-style: normal;
  line-height: 20px;
  transition: all 0.3s ease;
}

.upload-file.active span {
  color: #4A68F8;
}

.upload-file.error {
  border: 1px solid #FF4A4A;
  background: #FDE8E8;
}

.close-btn {
  width: 32px;
  height: 32px;
  border: none;
  cursor: pointer;
  background-color: #F2F4F7;
  border-radius: 3000px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  background-color: #E4E7EC;
}

.cross {
  padding: 8px;
}

.modal-header {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  border: none;
  padding: 0 !important;
  gap: 2px;
}

.modal-header-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
}

.modal-header-right {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}

.tab-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  border-bottom: 1px solid #E5E7EB;
  padding-bottom: 0;
  margin-bottom: 15px;
}

.tab-item {
  padding: 5px 0;
  border: none;
  background: transparent;
  font-family: euclid_regular, sans-serif;
  font-size: 14px;
  color: #9CA3AF;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  position: relative;
  border-bottom: 2px solid transparent;
  align-items: center;
  justify-content: center;
  display: flex
}

.tab-item:hover {
  color: #6B7280;
}

.tab-item.active {
  color: #040C2D;
  font-family: euclid_medium, sans-serif;
  border-bottom: 2px solid #10B981;
  align-items: center;
  justify-content: center;
  display: flex;
}

.tab-item:focus {
  outline: none;
}

.modal-header-txt {
  font-family: euclid_semi_bold, sans-serif;
  color: #040C2D;
  font-size: 18px;
  font-style: normal;
  line-height: 20px;
  justify-content: center;
  display: flex;
  align-items: center;
  gap: 5px;
}

.modal-header-description {
  font-family: euclid_medium, sans-serif;
  color: #667085;
  font-size: 12px;
  font-style: normal;
  line-height: 24px;
}

.selected-files, .existing-documents {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.upload-file.limit-full {
  border: 1px solid #FF4A4A;
  background: #FDE8E8;
}

.upload-file.limit-full span {
  color: #EF4444;
  font-family: euclid_regular, sans-serif;
  font-size: 12px;
  margin-top: 10px;
}

.form-textarea {
  width: 100%;
}


.type-row {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: 5px;
}

.radio-item {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 2px 0;
}

.radio-input {
  display: none;
}

.radio-custom {
  width: 16px;
  height: 16px;
  border: 1px solid #D1D5DB;
  border-radius: 50%;
  position: relative;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.radio-custom::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #6B7280;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.radio-input:checked + .radio-custom {
  border-color: #3DA33E;
  background-color: #3DA33E;
  background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='1.66602' y='1.66797' width='16.6667' height='16.6667' rx='8.33333' fill='%233DA33E'/%3E%3Cpath d='M8.6458 13.9597L5.59184 10.9056C5.26498 10.5788 5.26498 10.0488 5.59185 9.72192L5.62341 9.69037C5.95029 9.36349 6.48026 9.3635 6.80713 9.69038L8.6458 11.5291L12.9151 7.25983C13.242 6.93295 13.7719 6.93296 14.0988 7.25983L14.1304 7.2914C14.4572 7.61827 14.4572 8.14823 14.1304 8.47511L8.6458 13.9597Z' fill='white'/%3E%3C/svg%3E");
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: center;
}

.radio-label {
  font-family: euclid_regular, sans-serif;
  color: #6B7280;
  font-size: 14px;
  line-height: 20px;
  user-select: none;
}

.radio-item:hover .radio-custom {
  border-color: #9CA3AF;
}

.radio-input:checked + .radio-custom + .radio-label {
  color: #374151;
}

.select-view span {
  font-family: euclid_medium, sans-serif;
  color: #667085;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
}

.select-view.selected span {
  color: #040C2D;
}

.dropdown-wrapper {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.dropdown-wrapper span{
  font-size: 14px;
  font-family: euclid_medium, sans-serif;
}

.dropdown {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: 15px;
  background-color: #f5f5f5;
  border-radius: 8px;
  cursor: pointer;
}

.footer-controls{
  display: flex;
  flex-direction: row;
}

.footer-controls span{
  font-size: 12px;
  color: #868c98;
}

.primary-button {
  width: 100%;
}


.upload-error-span {
  color: #EF4444;
  font-family: euclid_regular, sans-serif;
  font-size: 12px;
}

.translation-title{
  font-size: 14px;
  font-family: euclid_medium, sans-serif;
}

.upload-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  background-color: #ebedfb;
  border-radius: 8px;
  margin-bottom: 20px;
  font-family: euclid_regular, sans-serif;
  font-size: 14px;
  color: #4A68F8;
}

.language-dropdown {
  position: relative;
  width: 100%;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  background: white;
  cursor: pointer;
}

.selected-language {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 8px;
  background-color: #f5f5f5;

  .flag {
    font-size: 16px;
  }

  .name {
    flex: 1;
    font-family: euclid_regular, sans-serif;
    font-size: 14px;
    color: #374151;
  }

  img {
    transition: transform 0.2s ease;
    width: 12px;
    height: 12px;

    &.rotated {
      transform: rotate(180deg);
    }
  }
}

.language-options {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
  margin-top: 2px;
}

.language-option {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  gap: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-bottom: 1px solid #F3F4F6;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #F9FAFB;
  }

  &.selected {
    background-color: #EBF8FF;
    color: #1D4ED8;
  }

  .flag {
    font-size: 16px;
    width: 20px;
  }

  .name {
    font-family: euclid_regular, sans-serif;
    font-size: 14px;
    flex: 1;
  }
}

/* Scrollbar stilleri */
.language-options::-webkit-scrollbar {
  width: 6px;
}

.language-options::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.language-options::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.language-options::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
